
import React, { useEffect, useState } from "react";
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";
import Utility from "../../../utility/Utility";
import ReportService from "../../../services/report-service/ReportService";
import { TextField } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));

function Earnings() {
  const [fullName, setFullName] = useState<any>("");
  const getInitialDate = (days: number) => {
    const newDt = new Date();
    newDt.setDate(newDt.getDate() + days);
    return moment(newDt).format("YYYY-MM-DD");
  };

  const [selectedToDate, setSelectedToDate] = useState(getInitialDate(0));
  const [selectedFromDate, setSelectedFromDate] = useState(getInitialDate(-30));
  const [maxDate, setMaxToDate] = useState(getInitialDate(0));
  const [validationMessage, setvalidationMessage] = useState("");
  const [isValidate, setIsValidate] = useState(false);
  const classes = useStyles();
  const [reportData, setReportData] = useState("");
  const [pdfBytes, setpdfBytes] = useState("");
  const [showDownloadBtn, setShowDownloadBtn] = useState(false);

  // NEW: type filter state ("all" | "calls" | "messages" | "earnings")
  const [reportTypeUI, setReportTypeUI] =
    useState<"all" | "calls" | "messages" | "earnings">("all");

  const handleFromDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedFromDate(e.target.value);
  };

  const handleFullNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFullName(e.target.value);
  };

  const handleToDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedToDate(e.target.value);
  };

  // NEW: radio change handler – normalize to our union
  const handleReportTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const v = e.target.value.toLowerCase();
    if (v === "all" || v === "calls" || v === "messages" || v === "earnings") {
      setReportTypeUI(v as "all" | "calls" | "messages" | "earnings");
    }
  };

  const CurrentDate = () => {
    const currDate = new Date();
    return new Date(currDate.getFullYear(), currDate.getMonth(), currDate.getDate());
  };

  const parseDate = (dt: Date) => {
    return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
  };

  const getDateFromString = (date: string) => {
    return new Date(date);
  };

  const ClearSearchCriteria = () => {
    setSelectedToDate(getInitialDate(0));
    setSelectedFromDate(getInitialDate(-30));
    setFullName("");
    setReportTypeUI("all");       // reset to All
    setIsValidate(false);
    setvalidationMessage("");
    setShowDownloadBtn(false);
    setReportData("");
    setpdfBytes("");
  };

  const Download = () => {
    const blob = Utility.b64toBlob(pdfBytes);
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Transaction Earnings";
    a.click();
    URL.revokeObjectURL(url);
  };

  const getReport = () => {
    // ✅ Corrected validation:
    const from = parseDate(getDateFromString(selectedFromDate));
    const to   = parseDate(getDateFromString(selectedToDate));
    const today = CurrentDate();

    if (from > to) {
      setIsValidate(true);
      setvalidationMessage("From Date cannot be greater than To Date");
      return;
    }

    if (from > today || to > today) {
      setIsValidate(true);
      setvalidationMessage("From Date and To Date cannot be in future");
      return;
    }

    setIsValidate(false);
    setvalidationMessage("");

    const frmDate = selectedFromDate;
    const toDateEndOfDay = moment(selectedToDate + " 23:59:59").format("MM/DD/YYYY hh:mm:ss A");

    const fromParam = frmDate === "Invalid date" ? "0001-01-01" : frmDate;
    const toParam   = toDateEndOfDay === "Invalid date" ? "0001-01-01" : toDateEndOfDay;

    // Map UI values to backend tokens: "all" | "call" | "message" | "earning"
    const typeParam =
      reportTypeUI === "all"      ? "all" :
      reportTypeUI === "calls"    ? "call" :
      reportTypeUI === "messages" ? "message": "call";

    // ── Service call (see notes below) ───────────────────────────────────────
    ReportService.GetEarningDetailReport(
      fromParam,
      toParam,
      fullName,
    typeParam
    ).then((res: any) => {
      setReportData(res.data.result?.reportHTML ?? "");
      setpdfBytes(res.data.result?.reportBytes ?? "");
      setShowDownloadBtn(true);
    });
  };

  return (
    <div className="col-10 mt-4">
      <h3>Earnings</h3>
      <div className="pt-2">
        <form className={classes.container} noValidate>
          <label className="m-3 ">Name :</label>
          <input
            className="form-control m-3 form-control-sm"
            type="text"
            name="txtfullName"
            value={fullName}
            onChange={handleFullNameChange}
            style={{ backgroundColor: "#fff", width: "185px" }}
            placeholder="Name"
          />

          <TextField
            id="dateFrom"
            label="From Date"
            type="date"
            value={selectedFromDate}
            onChange={handleFromDateChange}
            InputProps={{ inputProps: { max: selectedToDate } }}
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
          />

          <TextField
            id="dateTo"
            label="To Date"
            type="date"
            value={selectedToDate}
            onChange={handleToDateChange}
            InputProps={{ inputProps: { max: maxDate } }}
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
          />

          {/* Type filter radio group */}
          <div className="form-group mb-2">
            <div className="p-2">

              <div className="custom-control custom-radio custom-control-inline">
                <input
                  type="radio"
                  value="All"
                  id="type-all"
                  name="type-filter"
                  className="custom-control-input"
                  checked={reportTypeUI === "all"}
                  onChange={handleReportTypeChange}
                />
                <label className="custom-control-label" htmlFor="type-all">All</label>
              </div>

              <div className="custom-control custom-radio custom-control-inline">
                <input
                  type="radio"
                  value="Calls"
                  id="type-calls"
                  name="type-filter"
                  className="custom-control-input"
                  checked={reportTypeUI === "calls"}
                  onChange={handleReportTypeChange}
                />
                <label className="custom-control-label" htmlFor="type-calls">Calls</label>
              </div>

              <div className="custom-control custom-radio custom-control-inline">
                <input
                  type="radio"
                  value="Messages"
                  id="type-messages"
                  name="type-filter"
                  className="custom-control-input"
                  checked={reportTypeUI === "messages"}
                  onChange={handleReportTypeChange}
                />
                <label className="custom-control-label" htmlFor="type-messages">Messages</label>
              </div>



              <div className="custom-control custom-radio custom-control-inline">
                <button
                  color="secondary"
                  onClick={ClearSearchCriteria}
                  type="button"
                  className="btn btn-sm float-right search-btn stnd-btn view-r-btn"
                >
                  Reset
                </button>
                <button
                  color="secondary"
                  onClick={getReport}
                  type="button"
                  className="btn btn-sm float-right search-btn stnd-btn view-r-btn"
                >
                  View Report
                </button>
                {isValidate && (
                  <span className="error-msg" style={{ color: "#ff0000" }}>
                    {validationMessage}
                  </span>
                )}
              </div>
            </div>
          </div>
        </form>

        <div className="mt-4">
          <div className="mb-0 heading">
            <h5>
              Report{" "}
              {showDownloadBtn ? (
                <button
                  color="secondary"
                  onClick={Download}
                  type="button"
                  className="btn btn-sm btn-outline-secondary float-right"
                >
                  Save as
                </button>
              ) : (
                ""
              )}
            </h5>
          </div>
          <div className="report-view-bx">
            <div dangerouslySetInnerHTML={{ __html: reportData }} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Earnings;
